/* Round avatar: renders the photo when `src` is given, otherwise colored initials. */
export default function Avatar({ initials, color, size = 34, fontSize = 12, style, src }) {
  if (src) {
    return (
      <img
        className="avatar"
        src={src}
        alt=""
        style={{ width: size, height: size, objectFit: 'cover', ...style }}
      />
    );
  }
  return (
    <div
      className="avatar"
      style={{ width: size, height: size, fontSize, background: color, ...style }}
    >
      {initials}
    </div>
  );
}
